import { User, Users } from 'lucide-react';

export const ROLE_OPTIONS = [
  {
    value: 'parent',
    label: "I'm a parent",
    description: 'Enrolling my kid(s)',
    icon: Users,
  },
  {
    value: 'student',
    label: "I'm a student",
    description: 'Enrolling myself',
    icon: User,
  },
];